import * as React from 'react'

import Button from '@mui/material/Button'

import { useHandlers } from './hooks'
import { IReferral } from '@sales-center/common'
import { PlusIcon } from '@sales-center/components'
import { ReferralFormVariant } from '@user/components/Referrals/components/UpdateReferral/TidalUpdateReferral'

export type Props = {
  disabled: boolean
  onClick: () => void
  closeReferralDrawer: () => void
  referral?: IReferral
  variant?: 'outlined' | 'contained' | 'text'
  updateReferralDrawerOpen: boolean
  formVariant: ReferralFormVariant
}

export function TidalReferralActionButton(props: Props) {
  const {
    disabled,
    referral,
    variant = 'text',
    updateReferralDrawerOpen,
    closeReferralDrawer,
    formVariant,
  } = props
  const referralHasValues =
    referral && (referral.referralValue || referral.referralType)
  const { handleClick } = useHandlers({ ...props })

  if (
    formVariant === ReferralFormVariant.Inline &&
    (referralHasValues || updateReferralDrawerOpen)
  ) {
    return (
      <Button
        sx={{ textTransform: 'none' }}
        disableElevation
        onClick={closeReferralDrawer}
        variant={variant}
        data-test-id="editReferralBtn"
      >
        Cancel
      </Button>
    )
  }

  return formVariant !== ReferralFormVariant.Inline && referralHasValues ? (
    <Button
      sx={{ textTransform: 'none' }}
      disableElevation
      onClick={handleClick}
      variant={variant}
      data-test-id="editReferralBtn"
    >
      Edit Referral
    </Button>
  ) : (
    <>
      <Button
        variant={variant}
        onClick={handleClick}
        disabled={disabled}
        sx={{ textTransform: 'none' }}
        data-test-id="addReferralBtn"
        startIcon={<PlusIcon />}
      >
        Add Referral
      </Button>
    </>
  )
}
